export const EXTENSION_STATUS = {
  INITIATED: 'Extension Initiated',
  INSURANCE_UNDER_REVIEW: 'Insurance under review',
  INSURANCE_REVIEW_COMPLETED: 'Insurance Review Completed',
  IN_PROCESS: 'Extension In Process',
  COMPLETED: 'Extension Completed',
  RETRACTED: 'Retracted',
} as const;

export type ExtensionStatus = typeof EXTENSION_STATUS[keyof typeof EXTENSION_STATUS];

export const EXTENSION_PROGRESS_STEPS: ExtensionStatus[] = [
  EXTENSION_STATUS.INITIATED,
  EXTENSION_STATUS.INSURANCE_UNDER_REVIEW,
  EXTENSION_STATUS.INSURANCE_REVIEW_COMPLETED,
  EXTENSION_STATUS.IN_PROCESS,
  EXTENSION_STATUS.COMPLETED,
];

export const LOAN_DQ_FLAG_LABEL = {
  DELINQUENT: 'This loan is delinquent.',
  DQ_IN_FORECLOSURE: 'This loan is delinquent and in Foreclosure.',
} as const;